<template>
  <b-row class="mt-4">
    <b-col
      class="mt-1"
      cols="6"
    >
      {{ $t('components.custom.planning.booking-details-modal.participant-payment-modal.sold') }}
    </b-col>
    <b-col cols="6">
      <div class="d-flex flex-row align-content-center align-items-center">
        <b-input-group>
          <b-form-input
            v-model="toPay.value"
            min="0.00"
            step="0.5"
            type="number"
            size="sm"
            class="background-light-blue-inputs"
            :placeholder="$t('general.actions.numbers.zero')"
          >
          </b-form-input>
          <b-input-group-append is-text>
            <div>{{ $currency }}</div>
          </b-input-group-append>
        </b-input-group>
      </div>
    </b-col>
  </b-row>
</template>
<script>
export default {
  data: () => ({
    coinsIcons: require('@/assets/coins.svg')
  }),
  props: {
    toPay: {
      type: Object,
      default: () => {}
    }
  },
}
</script>
<style lang="scss" scoped>

.coins-container {
  border: 1px solid #ced4da;
  border-left: unset;
  background-color: #EBEBEB;
  border-bottom-right-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
  border-top-left-radius: unset;
  font-size: 0.875rem;
}

.form-control-coin-sm {
  height: calc(1.494em + 0.5rem);
  padding: 0.24rem 0.5rem;
  font-size: 0.87rem;
  line-height: 0;
  border-radius: 0.2rem;
}

/deep/ .input-group-text {
  line-height: 0;
  color: #092772;
}

.custom-left-borders {
  border-bottom-left-radius: unset;
  border-top-left-radius: unset;
}

.custom-right-borders {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
</style>
